import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initRelatedProducts from '../sections/product/related-products';
import initProductStickyAtc from '../components/product-sticky-atc';
import initProductGalleryLightbox from '../components/product-gallery-lightbox';
import initProductGalleries from '../components/product-gallery';
import initProductModel from '../components/product-model';
import initProductShare from '../components/product-share';
import initProductKeyFeatures from '../components/product-key-features';
import initProductNextDayDelivery from '../components/product-next-day-delivery';
import initProductContentDrawers from '../components/product-content-drawers';
import initProductWarrantyDrawer from '../components/product-warranty-drawer';
ready(() => {
  initProductContentDrawers();
  initProductWarrantyDrawer();
  initQuantityInputs();
  initProductKeyFeatures();
  initProductNextDayDelivery();
  initProductVariants();
  initRelatedProducts();
  initProductStickyAtc();
  initProductGalleries();
  initProductGalleryLightbox();
  initProductModel();
  initProductShare();
});

onShopifySectionLoad(() => {
  initRelatedProducts();
  initProductGalleries();
  initProductGalleryLightbox();
  initProductModel();
  initProductShare();
  initProductKeyFeatures();
  initProductNextDayDelivery();
  initProductContentDrawers();
  initProductWarrantyDrawer();
});
